function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.625 9H12.375V10.125H5.625V9ZM5.625 5.625H12.375V6.75H5.625V5.625Z",
  fill: "#7C8288"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 16.875L5.526 15.0227C4.53563 14.4958 3.70742 13.7092 3.13027 12.7472C2.55312 11.7853 2.24881 10.6843 2.25 9.5625V2.25C2.2503 1.95172 2.36892 1.66575 2.57984 1.45483C2.79075 1.24392 3.07673 1.1253 3.375 1.125H14.625C14.9233 1.1253 15.2093 1.24392 15.4202 1.45483C15.6311 1.66575 15.7497 1.95172 15.75 2.25V9.5625C15.7512 10.6843 15.4469 11.7853 14.8697 12.7472C14.2926 13.7092 13.4644 14.4958 12.474 15.0227L9 16.875ZM3.375 2.25V9.5625C3.37407 10.4804 3.62312 11.3812 4.09543 12.1683C4.56774 12.9553 5.24547 13.5989 6.05588 14.0299L9 15.5998L11.9441 14.0304C12.7546 13.5994 13.4324 12.9557 13.9047 12.1686C14.377 11.3814 14.626 10.4805 14.625 9.5625V2.25H3.375Z",
  fill: "#7C8288",
  stroke: "#7C8288",
  strokeWidth: 0.6
});

const SvgGameRule = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGameRule, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/gameRule.8d69eac3.svg";
export { ForwardRef as ReactComponent };